<template>
    <div class="g-popup js-popup-bg" v-show="show">
        <!-- 查看趋势弹窗 start -->
        <div class="popup-con trend-popup">
            <div class="popup-close" @click="close"><i class="ico ico-close"></i></div>
            <h5 class="popup-title">{{item.articleTitle}}</h5>
            <!-- 中间内容需要给出上下左右的margin或padding -->
            <div class="trend-popup-con">
                
                <!-- 条件筛选 [[ -->
                <ul class="inf-filter-con">
                    <li class="inf-publish-time">
                        <p class="inf-filter-con-tit f-inlineblock-top">时间</p>
                        <div class="inf-publish-time-date f-inlineblock-middle">
                            <el-date-picker ref="datePicker"
                                v-model="dateVal"
                                type="daterange"
                                range-separator="至"
                                :start-placeholder="defaultsDate"
                                :end-placeholder="defaulteDate"
                                :picker-options="pickerOptions"
                                value-format="yyyy-MM-dd"
                                @change="onDateChange"
                            >
                            </el-date-picker>
                        </div>
                    </li>
                    <li class="inf-label">
                        <p class="inf-filter-con-tit f-inlineblock-top">类型</p>
                        <div class="inf-label-con f-inlineblock-top">
                            <!-- 点击选中的标签后添加class="js-inf-btn-active",其余的不添加 -->
                            <a class="js-inf-btn-active inf-label-btn g-btn" href="javascript:;" v-text="articleText"></a>
                        </div>
                    </li>
                    <li class="inf-label">
                        <p class="inf-filter-con-tit f-inlineblock-top">媒体</p>
                        <div class="inf-label-con f-inlineblock-top">
                            <a class="inf-label-btn g-btn" href="javascript:;" :class="{'js-inf-btn-active': params.cid === ''}" @click="changeMedia()">全部</a>

                            <a class="inf-label-btn g-btn" href="javascript:;" v-for="mediaItem in mediaList" :key="mediaItem.id" :class="{'js-inf-btn-active': params.cid === mediaItem.id}" @click="changeMedia(mediaItem.id)">{{mediaItem.text}}</a>
                        </div>
                    </li>
                    <!-- <li class="inf-label">
                        <p class="inf-filter-con-tit f-inlineblock-top">账号</p>
                        <div class="inf-label-con f-inlineblock-top">
                            <a class="js-inf-btn-active inf-label-btn g-btn" href="javascript:;">全部</a>
                        </div>
                    </li> -->
                </ul>
                <!-- 条件筛选 ]] -->
                
                <div class="inf-chart">
                    <p class="inf-filter-con-tit f-inlineblock-top">阅读量</p>
                    <div class="inf-chart-con f-inlineblock-top">
                        <div class="inf-chart-radio">
                            <!-- 单选选中的添加class="inf-radio-active"反之去掉class="inf-radio-active" -->
                            <label class="inf-radio-con f-inlineblock-middle inf-radio-active">
                                <input class="g-input" type="radio" name="popup-chart" value="" checked="checked" >
                            </label>
                            <p class="inf-radio-name f-inlineblock-top">阅读量</p>
                        </div>
                        <div id="article-chart"></div>
                        <!-- <img src="~Assets/img/pages/v4/img-4.jpg"> -->
                    </div>
                </div>
            </div>
        </div>	    	
        <!-- 查看趋势 end -->
    </div>
</template>
<style lang="scss" scoped>
    @import '~Assets/sass/pages/v4/information/information.scss';
    #article-chart{
        width: 100%;
        height: 265px;
    }
</style>

<script>
import {
    GetArticlePvVvDaily 
} from 'Services/getData.js';
export default {
    data() {
        return {
            dateVal: [],
            defaultsDate: '',
            defaulteDate: '',
            defaultDate: [],
            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() > Date.now(); //这里就是设置当天后的日期不能被点击
                }
            },
            show: false,
            item: {},
            articleText: '',
            mediaList: '',
            params: {
                aid: '',
                sDate: '',
                eDate: '',
                cid: ''
            },
            chart: '',
            chartData: {}
        }
    },
    components: {},
    computed: {},
    mounted(){
        this.initPicker();
    },
    methods: {
        initPicker(){
            this.dateVal = [];
            let startDate = Date.now() - 8.64e7*7;
            let endDate = Date.now() - 8.64e7;
            this.params.sDate = this.$common.formatDate(startDate, '-');
            this.params.eDate = this.$common.formatDate(endDate, '-');
            this.dateVal[0] = this.$common.formatDate(startDate, '-');
            this.dateVal[1] = this.$common.formatDate(endDate, '-');
            this.defaultsDate = this.dateVal[0];
            this.defaulteDate = this.dateVal[1];
        },
        drawLine(){
            let data = [];
            let xy = 'iTime*PVVV';
            data = this.chartData;
            if(this.chart){
                this.chart.destroy();
            }
            this.chart = new G2.Chart({
                container: 'article-chart',
                forceFit: true,
                width: '100%',
                height: 265,
                padding: [ 20, 40, 45, 80 ]
            });
            let chart = this.chart;
            let defs = {
                'PVVV': {
                    alias: '阅读量'
                }
            };
            chart.source(data, defs);
            chart.scale('value', {
                min: 0
            });
            chart.scale('iTime', {
                range: [0, 1]
            });
            chart.tooltip({
                crosshairs: {
                    type: 'line'
                }
            });
            chart.line().position(xy);
            chart.point().position(xy).size(4).shape('circle').style({
                stroke: '#fff',
                lineWidth: 1
            });
                
            chart.render();
            G2.track(false)
        },
        changeMedia(id = ''){
            this.params.cid = id;
            this.getChartData();
        },
        getData(item){
            this.$refs.datePicker.value = [];
            this.dateVal[0] = item.sDate;
            this.dateVal[1] = item.eDate;
            // debugger
            this.item = item;
            this.params.sDate = item.sDate;
            this.params.eDate = item.eDate;
            this.params.aid = item.articleId;
            // this.params.aid = item.id;
            this.articleType();
            this.getChartData();
        },
        async getChartData(){
            let res = await GetArticlePvVvDaily(this.params);
            this.chartData = res.data.data;
            this.drawLine();
        },
        articleType(){
                
            switch(this.item.articleType){
            case 0:
                this.articleText = '图文';
                break;
            case 1:
                this.articleText = '视频';
                break;
            case 50:
                this.articleText = '小说';
                break;
            case 60:
                this.articleText = '漫画';
                break;
            }
        },
        onDateChange(choiceDate){
            if(choiceDate){
                this.params.sDate = choiceDate[0];
                this.params.eDate = choiceDate[1];
            }else{
                let startDate = Date.now() - 8.64e7*7;
                let endDate = Date.now() - 8.64e7;
                this.params.sDate = this.$common.formatDate(startDate, '-');
                this.params.eDate = this.$common.formatDate(endDate, '-');
                this.dateVal = [];
            }
            this.getChartData();
        },
        close(){
            this.show = false;
        }
    }
}
</script>